import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { CatalogPricesRequestType } from '~/shared/api/types/catalog';

import { getCatalogPrices } from '../api/getCatalogPrices/getCatalogPrices';

type UseGetCatalogPricesParams = {
  enabled?: boolean;
} & CatalogPricesRequestType;

export const useGetCatalogPrices = ({
  enabled = true,
  ...params
}: UseGetCatalogPricesParams) => {
  const { setValue } = useFormContext();

  const query = useQuery({
    queryKey: ['catalogPrices', params],
    queryFn: () => getCatalogPrices(params),
    enabled: enabled && Boolean(params.productId),
  });

  useEffect(() => {
    if (query.data && query.isSuccess) {
      setValue('amount', query.data);
    }
  }, [query.data, query.isSuccess, setValue]);

  return query;
};
